import { Button } from "@leap4/frontend";

interface InternalOnlyToggleButtonProps {
  internalOnly: boolean;
  onToggle: (next: boolean) => void;
}

const InternalOnlyToggleButton = ({ internalOnly, onToggle }: InternalOnlyToggleButtonProps) => (
  <Button
    variant="contained"
    disableElevation
    size="small"
    onClick={() => onToggle(!internalOnly)}
    style={{
      minWidth: 96,
      color: "#ffffff",
      background: internalOnly ? "#ed6c02" : "#0288d1",
      backgroundImage: "none",
    }}
  >
    {internalOnly ? "Internal only" : "External"}
  </Button>
);

export default InternalOnlyToggleButton;
